import React from "react";

import { Grid } from "@material-ui/core";
import { Formik, Form } from "formik";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";

import { patchSaleLot } from "actions";

import { Button, SecondaryButton } from "components/Form";
import { SaleLotLabelSelectorField } from "components/Form/Fields/SaleLotLabelSelectorField";
import {
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
} from "components/MaterialDialog";

import { selectDeploymentIdByConsignmentIdLookup } from "selectors";

export const LotLabelsModal = ({ onClose, saleLot }) => {
  const dispatch = useDispatch();
  const save = values => {
    dispatch(
      patchSaleLot(
        { labels: values.labels, id: saleLot.id },
        { changeReason: "Labels updated" },
      ),
    );
    onClose();
  };

  const deploymentId = useSelector(selectDeploymentIdByConsignmentIdLookup)[
    saleLot.consignment_id
  ];

  return (
    <Dialog open maxWidth="sm" fullWidth>
      <Formik onSubmit={save} initialValues={saleLot}>
        <Form>
          <DialogTitle onClose={onClose}>Lot Labels</DialogTitle>
          <DialogContent dividers>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <SaleLotLabelSelectorField
                  name="labels"
                  label="Labels"
                  deploymentId={deploymentId}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <SecondaryButton onClick={onClose}>Cancel</SecondaryButton>
            <Button type="submit">Save</Button>
          </DialogActions>
        </Form>
      </Formik>
    </Dialog>
  );
};

LotLabelsModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  saleLot: PropTypes.object.isRequired,
};
